import React from 'react';
import { PostAdd } from '@material-ui/icons';
import IntlMessages from '../../../utils/IntlMessages';

export const sidebarNavs = [
	{
		name: <IntlMessages id='sidebar.main' />,
		type: 'section',
		children: [
			{
				name: 'Daily Dashboard',
				type: 'item',
				link: '/dashboard',
			},
			{
				name: 'Automation configuration',
				type: 'item',
				link: '/automation-config',
			},
		],
	},
];

export const horizontalDefaultNavs = [
	{
		name: <IntlMessages id='sidebar.main' />,
		type: 'collapse',
		children: [
			{
				name: 'dashboard',
				type: 'item',
				icon: <PostAdd />,
				link: '/dashboard',
			},
		],
	},
];

export const minimalHorizontalMenus = [
	{
		name: <IntlMessages id='sidebar.main' />,
		type: 'collapse',
		children: [
			{
				name: 'dashboard',
				type: 'item',
				icon: <PostAdd />,
				link: '/dashboard',
			},
		],
	},
];
